
import { Check, Calendar, UserRound, MapPin } from 'lucide-react';

const steps = [
  {
    icon: Calendar,
    title: 'Book online',
    description: 'Confirmation is immediate. Cancel for free up to 24h before pickup',
  },
  {
    icon: UserRound,
    title: 'Meet your driver',
    description: 'Your driver will track your flight and wait if there are delays',
  },
  {
    icon: MapPin,
    title: 'Arrive at your destination',
    description: 'Get to your destination quickly and safely',
  },
  {
    icon: Check,
    title: 'Enjoy your trip',
    description: 'Rate your experience and travel with us again',
  },
];

const HowItWorksSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl font-serif font-bold text-secondary-dark mb-4">
            Airport transfers made easy
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Book your airport taxi in minutes
          </p>
          <p className="text-gray-600">
            Experience hassle-free airport transfers with our premium service. 
            From instant booking confirmation to seamless airport pickup, 
            we ensure a smooth journey every time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div
                key={index}
                className="flex flex-col items-center text-center group hover:scale-105 transition-transform duration-300"
              >
                <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                  <Icon className="w-10 h-10 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-secondary-dark mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 max-w-xs">{step.description}</p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
